import { render, staticRenderFns } from "./NeedMasterProposals.vue?vue&type=template&id=173ded39&scoped=true&"
import script from "./NeedMasterProposals.vue?vue&type=script&lang=js&"
export * from "./NeedMasterProposals.vue?vue&type=script&lang=js&"
import style0 from "./NeedMasterProposals.vue?vue&type=style&index=0&id=173ded39&prod&lang=css&"
import style1 from "./NeedMasterProposals.vue?vue&type=style&index=1&id=173ded39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ded39",
  null
  
)

export default component.exports